<template>
	<div style="height: 680px; overflow-y: auto; overflow-x: hidden">
		<card>
			<div class="multiple">
				<div class="child-div">时间区间</div>
				<RadioGroup v-model="childTimePeriod" @on-change="getList">
					<Radio label="0"><span>不限</span></Radio>
					<Radio label="1"><span>今日</span></Radio>
					<Radio label="2"><span>昨日</span></Radio>
					<Radio label="3"><span>本周</span></Radio>
					<Radio label="4"><span>上周</span></Radio>
					<Radio label="5"><span>本月</span></Radio>
					<Radio label="6"><span>上月</span></Radio>
					<Radio label="7"><span>自定义</span></Radio>
					<DatePicker :value="childTimePeriodDate" @on-change="timePeriodDateChange" type="daterange"
						placeholder="选择日期" style="width: 200px"></DatePicker>
				</RadioGroup>
			</div>
			<div class="multiple">
				<div class="child-div">排序类型</div>
				<Select placeholder="排序类型" v-model="order_type" style="width: 100px;" @on-change="getList">
					<Option value="1">通话时间</Option>
					<Option value="2">通话时长</Option>
				</Select>
				<Button style="margin-left: 20px;" type="primary" v-on:click="initSearch()">重置</Button>
			</div>
		</card>
		<Table border :columns="columns" :data="callData">
			<template slot-scope="{ row }" slot="clientname">
				<span  style="color:#63B3E6;cursor: pointer;"@click.stop="edit" :data-id="row.client_id" :data-name="row.clientname" type="info">{{row.clientname}}</span>
			</template>
		</Table>
		<div class="pager1">
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
	</div>
</template>

<script>
	import {
		getCallLogList
	} from "../../../api/statics";
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		props: ['get_uid', 'timePeriod', 'timePeriodDate'],
		data() {
			return {
				columns: [{
						title: "序号",
						type: "index",
						align: 'center',
						width:'50px'
					},
					{
						title: "客户经理",
						key: "username",
						align: 'center'
					},
					{
						title: "通话号码",
						key: "phoneNumber",
						align: 'center'
					},
					{
						title: "备注姓名",
						key: "name",
						align: 'center'
					},
					{
					    "title": "系统名称",
					    "slot": "clientname",
						"align":"center",
					},
					{
						title: "归属地",
						key: "numberLocation",
						align: 'center'
					},
					{
						title: "类型",
						key: "status_name",
						align: 'center'
					},
					{
						title: "通话时长",
						key: "duration",
						align: 'center'
					},
					{
						title: "时间",
						key: "call_time",
						align: 'center'
					},
				],
				childTimePeriod:'2',
				childTimePeriodDate:[],
				callData: [],
				count: 0,
				page: 1,
				pageSize: 10,
				pageSizeOpts: [10, 50, 100, 200, 500],
				order_type: '2'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.getList();
		},
		watch: {
			get_uid() {
				this.getList();
			},
			timePeriod() {
				this.childTimePeriod = this.timePeriod;
				this.getList();
			},
			timePeriodDate() {
				this.childTimePeriodDate = this.timePeriodDate;
				this.getList();
			},

		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			mySearch() {
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {}
				data.timePeriod = that.childTimePeriod;
				data.timePeriodDate = that.childTimePeriodDate;
				data.page = that.page;
				data.pageSize = that.pageSize;
				data.get_uid = that.get_uid;
				data.order_type = that.order_type;
				data.token = that.token;
				let res = await getCallLogList(that, data);
				that.callData = res.data.list;
				that.count = res.count;
				console.log(res)
			},
			changeSize(e) {
				this.page = 1;
				this.pageSize = e;
				this.getList();
			},
			changePage(e) {
				this.page = e;
				this.getList();
			},
			edit(e) {
				let that = this;
				let id = e.id || e.currentTarget.dataset.id;
				let name = e.name || e.currentTarget.dataset.name;
				this.$nextTick(function() {
					/*
					  that.oldDatas = that.datas;
					  that.editModal = true;
					  */
					this.$router.push({
						name: "newEditClue",
						params: {
							id: id,
							name: name,
							data: that.datas,
						},
					});
				});
			},
			timePeriodDateChange(e) {
				this.childTimePeriodDate = e;
				this.getList();
			},
			initSearch() {
				this.page = 1;
				this.childTimePeriod = '2';
				this.pageSize = 10;
				this.order_type = "2";
				this.getList();
			},
		},
	};
</script>

<style lang="less" scoped>
	.multiple {
	    display: flex;
	    justify-content: left;
	    margin-top: 10px;
	    align-items: center;
	
	    .child-div {
	        width: 70px;
	        height: 20px;
	        margin-right: 30px;
	        text-align-last: justify;
	    }
	}
	
	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>